
export const  Theme1= {
    typography: {
      heading: {
        fontSize: "48px",
        fontWeight: 800,
        textTransform: "uppercase",
      },
      body: {
        fontSize: "20px",
        fontWeight: 400,
      },
      button: {
        fontSize: "18px",
        fontWeight: 600,
        textTransform: "uppercase",
      },
    },
    colors: {
      heading: {
        color: "#111827",
      },
      body: {
        color: "#374151",
      },
      button: {
        color: "#ffffff",
        backgroundColor: "#99cc99",
      },
    },
    shadows: {
      heading: {
        textShadow: "0px 2px 4px rgba(0,0,0,0.15)",
      },
      button: {
        boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
      },
    },
    radius: {
      button: {
        borderRadius: "8px",
      },
    },
  }